import Articles from "./components/Home/Articles";

export default function Article(){
    return(
        <div>
            <Articles></Articles>
        </div>
    );
}